import React,{Component} from 'react';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from "react-toastify";
import SimpleReactValidator from "simple-react-validator";

import Button from '@material-ui/core/Button';
import TextField from "@material-ui/core/TextField";
import MenuItem from '@material-ui/core/MenuItem';

import Api from "../../../libraries/api";
import ErrorHandling from "../../../libraries/error-handling";
import { history } from "../../../shared/configure-store";
import defaultImage from "../../../images/images.png";

require('dotenv').config();
const validator = new SimpleReactValidator({locale: process.env.REACT_APP_LOCALE});

class SignatureAdd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            loadingButton: false,
            errors: {},
            showAdd: false,
            description: '',
            signee: '',
            materai: false,
            signatureImg: defaultImage,
            signatureFile: null,
            signatureFileName: '',
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Abadi - Add Signature';
    }

    showMessage = (status, message) => {
        if (status) toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT });
        else toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT });
    };

    handleChange (e, prop){
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
        this.setState({ [prop]: value });
    };

    handleToggleSelectSignature = () => {
        document.getElementById('signature').click();
    };

    handleSelectSignature = e => {
        this.setState({
            signatureImg: URL.createObjectURL(e.target.files[0]),
            signatureFile: e.target.files[0],
            signatureFileName: e.target.files[0].name
        });
    };

    handleSubmit = (e) => {
        e.preventDefault();

        if (!validator.allValid()) {
            this.setState({ errors: validator.getErrorMessages() });
            return false;
        }

        this.setState({ errors: {}, loading: true });

        let formData = new FormData();
        formData.append('description', this.state.description);
        formData.append('signee', this.state.signee);
        formData.append('materai', this.state.materai ? '1' : '0');
        formData.append('signature', this.state.signatureFile);

        Api.putFile(`/signatures`,{
            method: 'POST',
            body: formData
        }).then((resp) => {
            this.setState({ loading: false });
            history.push('/signatures');
            this.showMessage(true, 'Signature added');
        }).catch(err => {
            if (ErrorHandling.checkErrorTokenExpired(err)){
            } else {
                this.setState({ errors: err.errors, loading: false });
                this.showMessage(false, 'Invalid format data');
            }
        });
    };

    handleGo  = (link) => {
        history.push(link);
    };

    render() {
        return (
            <div className="row main-content">
                <div className="col-12 px-lg-5">
                    <h1 className="page-title">Create Signature</h1>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/signatures">Signature</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Create</li>
                        </ol>
                    </nav>
                </div>
                <div className="col-12 mt-3 px-lg-5">
                    <div className="table-wrapper">
                        <form name="add" id="addType" className="row" noValidate>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Description</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='description'
                                        name="description"
                                        label="Description"
                                        onChange={(e) => this.handleChange(e, 'description')}
                                        value={this.state.description}
                                        autoComplete="off"
                                        fullWidth
                                    />
                                    {validator.message('description', this.state.description, 'required')}
                                    <div className='text-danger'>{this.state.errors.description}</div>
                                </div>
                            </div>
                            <div className="col-md-6"></div>
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>Signee (A.N)</label>
                                    <TextField
                                        variant="outlined"
                                        type='text'
                                        id='signee'
                                        name="signee"
                                        label="Signee"
                                        onChange={(e) => this.handleChange(e, 'signee')}
                                        value={this.state.signee}
                                        autoComplete="off"
                                        fullWidth
                                    />
                                    {validator.message('signee', this.state.signee, 'required')}
                                    <div className='text-danger'>{this.state.errors.signee}</div>
                                </div>
                            </div>
                            <div className="col-md-6"></div>
                            <div className="col-md-6">
                                <div className="d-flex">
                                    <div>
                                        <input
                                            type="checkbox"
                                            id="materai"
                                            name="materai"
                                            checked={this.state.materai}
                                            onChange={e => this.handleChange(e, 'materai')}
                                            style={{width: '20px', height: '20px'}}
                                        />
                                    </div>
                                    <div className="ml-2 mb-2">Dengan Materai</div>
                                    {validator.message('materai', this.state.materai, 'boolean')}
                                    <div className='text-danger'>{this.state.errors.materai}</div>
                                </div>
                            </div>
                            <div className="col-md-6"></div>
                            <div className="col-md-12">
                                <div className="form-group">
                                    <label>Signature Image (Foto Tanda Tangan)</label>
                                    <div className="mb-3">
                                        <img
                                            style={{width: '200px', height: '200px', cursor: 'pointer'}}
                                            src={this.state.signatureImg}
                                            alt="Signature"
                                            onClick={() => this.handleToggleSelectSignature()}
                                        />
                                    </div>
                                    <div>
                                        <input
                                            type="file"
                                            id='signature'
                                            name="signature"
                                            accept="image/jpeg, image/png"
                                            onChange={this.handleSelectSignature}
                                        />
                                        <button className="btn-icon" onClick={() => this.handleDeleteFileSignature()}>
                                            <i className="fas fa-trash-alt"> </i>
                                        </button>
                                    </div>
                                    {validator.message('signature', this.state.signatureFile, 'required')}
                                    <div className='text-danger'>{this.state.errors.signature}</div>
                                </div>
                            </div>
                            <div className="col-12 text-center">
                                <Button className="mr-3" variant="contained" onClick={() => this.handleGo('/signatures')}>Cancel</Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className=""
                                    onClick={this.handleSubmit}
                                    disabled={this.state.loadingButton && 'disabled' }
                                >
                                    Submit{ this.state.loadingButton && <i className="fa fa-spinner fa-spin"> </i> }
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
                <ToastContainer autoClose={3000} />
            </div>
        )
    }
}

export default SignatureAdd;
